<template>
  <div>
    <h3>TODO</h3>
    <li>使用實際 api 串接(Store Announce)</li>

    <h3>20200531</h3>
    <li>store list</li>
    <li>announce list</li>
    <li>add edit function to each table</li>
    <li>order list use expand table</li>
    <li>add log out function</li>
    <li>使用實際 api 串接(User Account Order)</li>
    <li>檔案上傳功能</li>

    <h3>20200524</h3>
    <li>login</li>
    <li>reset pw</li>
    <li>user list</li>
    <li>order list</li>
    <li>navigation</li>
  </div>
</template>

<script>
  export default {
    name: "Log"
  }
</script>

<style scoped>

</style>